<template>
    <Layout :style="'min-height:' + innerHeight + 'px;'">
        <Header>
            <div class="header-left"><img src="@/assets/logo.png" /></div>
            <div class="header-right">
                <div class="card" @click="goModal">
                    <img
                        v-if="form_data.show_platform_logo"
                        class="wh32"
                        :src="form_data.show_platform_logo"
                    />
                    <img v-else class="wh32" src="@/assets/avatar.png" />
                    <div class="card-txt">{{ form_data.account }}</div>
                </div>
                <div class="card" @click="goLogout">
                    <img class="wh24 mr12" src="@/assets/close.png" />
                    <div>安全弹出</div>
                </div>
            </div>
        </Header>
        <Layout>
            <Sider class="default-bc" hide-trigger>
                <Menu
                    :active-name="String($route.name)"
                    ref="menu"
                    theme="light"
                    width="auto"
                    :open-names="open_names"
                >
                    <MenuItem name="index" to="/admin">
                        <Icon type="md-home" />首页
                    </MenuItem>
                    <MenuItem name="manage" to="/admin/manage">
                        <Icon type="md-card" />平台管理
                    </MenuItem>
                    <Submenu name="order">
                        <template slot="title">
                            <Icon type="md-card" />订单管理
                        </template>
                        <MenuItem name="order-version" to="/admin/order/version"
                            >版本订单</MenuItem
                        >
                        <MenuItem name="order-code" to="/admin/order/code"
                            >溯源码订单</MenuItem
                        >
                        <MenuItem name="order-plugin" to="/admin/order/plugin"
                            >插件订单</MenuItem
                        >
                    </Submenu>
                    <Submenu name="combo">
                        <template slot="title">
                            <Icon type="md-card" />套餐管理
                        </template>
                        <MenuItem name="combo-version" to="/admin/combo/version"
                            >版本套餐</MenuItem
                        >
                        <MenuItem name="combo-code" to="/admin/combo/code"
                            >溯源码套餐</MenuItem
                        >
                        <MenuItem name="combo-plugin" to="/admin/combo/plugin"
                            >插件套餐</MenuItem
                        >
                    </Submenu>
                    <MenuItem name="authorize" to="/admin/authorize">
                        <Icon type="md-list-box" />系统授权
                    </MenuItem>
                    <MenuItem name="journal" to="/admin/journal">
                        <Icon type="md-list-box" />操作日志
                    </MenuItem>
                    <MenuItem name="info" to="/admin/info">
                        <Icon type="md-text" />我的信息
                    </MenuItem>
                    <MenuItem name="version" to="/admin/version">
                        <Icon type="ios-information-circle-outline" />版本维护
                    </MenuItem>
                    <Submenu name="set">
                        <template slot="title">
                            <Icon type="md-card" />系统设置
                        </template>
                        <MenuItem name="set-we" to="/admin/set/we"
                            >关于我们</MenuItem
                        >
                        <MenuItem name="set-help" to="/admin/set/help"
                            >帮助使用</MenuItem
                        >
                        <MenuItem name="set-example" to="/admin/set/example"
                            >案例展示</MenuItem
                        >
                    </Submenu>
                    <MenuItem name="feedback" to="/admin/feedback">
                        <Icon type="md-card" />意见反馈
                    </MenuItem>
                </Menu>
            </Sider>
            <!-- Content -->
            <!-- height固定顶部 -->
            <Layout
                class="breadcrumb-container"
                :style="'height:' + (innerHeight - 64) + 'px;'"
            >
                <Breadcrumb class="breadcrumb-title">
                    <BreadcrumbItem
                        v-for="(item, index) in $route.matched"
                        :key="index"
                        >{{ item.meta.title }}</BreadcrumbItem
                    >
                </Breadcrumb>
                <Content><router-view></router-view></Content>
            </Layout>
        </Layout>
        <!-- 修改信息 -->
        <Modal
            v-model="edit_modal"
            title="修改信息"
            width="500"
            :mask-closable="false"
        >
            <Form :model="form_item" label-position="right" :label-width="130">
                <FormItem label="账号名称：">
                    <Input
                        class="w300"
                        v-model="form_item.platform_name"
                        type="text"
                        placeholder="请输入账号名称"
                    ></Input>
                </FormItem>
                <FormItem label="账号logo：">
                    <Upload
                        ref="upload"
                        :show-upload-list="false"
                        :format="['jpg', 'jpeg', 'png', 'gif']"
                        :max-size="2048"
                        :on-progress="handleProgress"
                        :on-format-error="handleFormatError"
                        :on-success="logoSuccess"
                        :headers="upload_headers"
                        :action="upload_action"
                    >
                        <div class="upload-container">
                            <img
                                v-if="form_data.show_platform_logo"
                                class="wh80"
                                :src="form_data.show_platform_logo"
                            />
                            <Icon
                                v-else
                                type="ios-add"
                                size="40"
                                color="#AEAEB3"
                            />
                        </div>
                    </Upload>
                </FormItem>
                <FormItem label="联系人：">
                    <Input
                        class="w300"
                        v-model="form_item.contact"
                        type="text"
                        placeholder="请输入联系人"
                    ></Input>
                </FormItem>
                <FormItem label="手机号：">
                    <Input
                        class="w300"
                        v-model="form_item.mobile"
                        type="number"
                        placeholder="请输入手机号"
                    ></Input>
                </FormItem>
                <FormItem label="我的账号：">
                    <Input
                        class="w300"
                        v-model="form_item.account"
                        type="text"
                        placeholder="请输入我的账号"
                    ></Input>
                </FormItem>
                <FormItem label="密码：">
                    <Input
                        class="w300"
                        v-model="form_item.password"
                        type="password"
                        password
                        placeholder="请输入密码"
                    ></Input>
                </FormItem>
            </Form>
            <div slot="footer">
                <Button @click="cancelModal">取消</Button>
                <Button class="theme-bc" type="warning" @click="submitModal"
                    >确认</Button
                >
            </div>
        </Modal>
    </Layout>
</template>
<script>
import { plat_logout, plat_info_index, plat_info_modify } from "@/api/index";
import config from "@/config/index";
import { getCookies } from "@/utils/helper";
import { removeCookies } from "@/utils/helper";
import { windowsRise } from "@/utils/dom";
export default {
    data() {
        return {
            upload_action: config.apiUrl + "/plat/other/upload",
            upload_headers: {
                "hlzw-plat-suyuan-token": getCookies("platToken"),
            },
            innerHeight: 0,
            open_names: [],
            form_data: {
                platform_name: "",
                show_platform_logo: "",
                contact: "",
                mobile: "",
                account: "",
                qrcode_count: "",
                expire_time: "",
            },
            form_item: {
                account: "",
                password: "",
                platform_name: "",
                platform_logo: "",
                contact: "",
                mobile: "",
            },
            edit_modal: false,
        };
    },
    metaInfo: {
        title: "首页",
        meta: [
            {
                name: "viewport",
                content:
                    "width=device-width,user-scalable=yes,initial-scale=0.3,minimum-scale=0.3,maximum-scale=2",
            },
        ],
    },
    mounted() {
        // 账户信息
        this.getInfo();
        this.restHeight();
        windowsRise(window, this.restHeight);
        this.selectMenu();
    },
    watch: {
        "$route.path"() {
            this.selectMenu();
        },
    },
    methods: {
        getInfo() {
            plat_info_index().then((res) => {
                this.form_data.platform_name = res.data.info.platform_name;
                this.form_data.show_platform_logo =
                    res.data.info.show_platform_logo;
                this.form_data.contact = res.data.info.contact;
                this.form_data.mobile = res.data.info.mobile;
                this.form_data.account = res.data.account;
                this.form_data.qrcode_count = res.data.info.qrcode_count;
                this.form_data.expire_time = res.data.expire_time;
                this.form_item.account = res.data.account;
                this.form_item.platform_name = res.data.info.platform_name;
                this.form_item.platform_logo = res.data.info.platform_logo;
                this.form_item.contact = res.data.info.contact;
                this.form_item.mobile = res.data.info.mobile;
            });
        },
        goModal() {
            this.edit_modal = true;
        },
        // 确定按钮
        submitModal() {
            plat_info_modify(this.form_item)
                .then((res) => {
                    this.goLogout();
                })
                .catch((err) => {
                    this.$Message.error(err.msg);
                });
        },
        // 取消按钮
        cancelModal() {
            this.edit_modal = false;
        },
        // 文件上传时
        handleProgress() {
            this.$Message.loading({
                content: "上传中...",
                duration: 0,
            });
        },
        // 文件上传类型错误
        handleFormatError() {
            this.$Message.destroy();
            this.$Message.warning("暂不支持上传此格式");
        },
        // 平台logo图片上传成功
        logoSuccess(e) {
            this.form_item.platform_logo = e.data.url;
            this.form_data.show_platform_logo = e.data.path;
            this.$Message.destroy();
            this.$Message.success(e.msg);
        },
        // 修改高度
        restHeight() {
            this.innerHeight = window.innerHeight - 2;
            console.log(this.innerHeight);
        },
        // 修改导航展开样式
        selectMenu() {
            this.open_names = [this.$route.name.split("-")[0]];
            this.$nextTick(() => {
                this.$refs.menu.updateOpened();
            });
        },
        // 退出
        goLogout() {
            plat_logout()
                .then((res) => {
                    this.$Message.success(res.msg);
                    removeCookies("platToken");
                    localStorage.clear();
                    this.$router.push({ path: "/" });
                })
                .catch((res) => {
                    this.$Message.error(res.msg);
                });
        },
    },
};
</script>

<style scoped>
/* 左上角LOGO图片 */
.header-left {
    float: left;
    display: flex;
    align-items: center;
    height: 100%;
}
/* 右上角退出登录DIV */
.header-right {
    float: right;
    display: flex;
    align-items: center;
    color: #484e66;
}
.card {
    display: flex;
    align-items: center;
    cursor: pointer;
}
/* 肖像 */
.wh32 {
    width: 32px;
    height: 32px;
    border-radius: 50%;
}
/* 昵称 */
.card-txt {
    margin: 0 12px;
    padding-right: 24px;
    height: 20px;
    line-height: 20px;
    border-right: 2px solid rgba(43, 63, 87, 0.5);
}
/* 退出登录 */
.wh24 {
    width: 24px;
    height: 24px;
}
.breadcrumb-title {
    margin-bottom: 24px;
    padding: 24px;
    display: flex;
    align-items: center;
    font-size: 16px;
    font-weight: 400;
    color: #484e66;
    background: #ffffff;
    box-shadow: 0px 0px 4px 0px rgba(82, 102, 136, 0.1);
    border-radius: 5px;
}
.breadcrumb-title:before {
    margin-right: 5px;
    content: "";
    display: inline-block;
    width: 3px;
    height: 20px;
    background: #ff761d;
    border-radius: 5px;
}
.default-bc {
    background: #fff;
}
.breadcrumb-container {
    padding: 24px;
    background: #f5f6fa;
}
.upload-container {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 80px;
    height: 80px;
    border-radius: 5px;
    border: 1px dashed #9fa5bb;
    cursor: pointer;
}
.wh80 {
    width: 80px;
    height: 80px;
    border-radius: 5px;
    border: 1px dashed #9fa5bb;
}
/* 顶部 */
.ivu-layout-header {
    padding: 0 24px;
    height: 64px;
    line-height: 64px;
    background: #fff;
    box-shadow: 0px 0px 4px 0px rgba(82, 102, 136, 0.1);
    border-bottom: 1px solid #eee;
}
/* 去掉原菜单样式 */
.ivu-menu-light.ivu-menu-vertical
    .ivu-menu-item-active:not(.ivu-menu-submenu):after {
    content: none;
}
/* 菜单样式 */
.ivu-menu-light.ivu-menu-vertical .ivu-menu-item-active:not(.ivu-menu-submenu) {
    border-radius: 10px;
    background: #ffffff;
    border: 1px solid #ff761d;
    color: #ff761d;
}
/* 菜单悬浮时字体颜色 */
.ivu-menu-item:hover {
    color: #ff761d !important;
}
/* 去除菜单右侧边框 */
.ivu-menu-vertical.ivu-menu-light:after {
    content: none;
}
::v-deep .ivu-menu-vertical .ivu-menu-submenu-title:hover {
    color: #ff761d !important;
}
</style>